/* ===================================================
   Mehaci Premium Wishlist
   Part 1
   Version 1.0
=================================================== */

const Wishlist = {

storageKey: "mehaciWishlist",

items: [],

init() {

this.load();

this.bindButtons();

this.updateIcons();

this.updateCounter();

this.observeDOM();

},

load() {

const saved = localStorage.getItem(this.storageKey);

if (saved) {

try {

this.items = JSON.parse(saved);

}

catch (e) {

this.items = [];

}

}

},

save() {

localStorage.setItem(

this.storageKey,

JSON.stringify(this.items)

);

this.updateCounter();

},

exists(id) {

return this.items.some(

item => item.id == id

);

},

add(product) {

if (this.exists(product.id))

return;

this.items.push(product);

this.save();

this.updateIcons();

document.dispatchEvent(

new CustomEvent(

"wishlist:updated"

)

);

},

remove(id) {

this.items = this.items.filter(

item => item.id != id

);

this.save();

this.updateIcons();

document.dispatchEvent(

new CustomEvent(

"wishlist:updated"

)

);

},

toggle(product) {

if (this.exists(product.id)) {

this.remove(product.id);

} else {

this.add(product);

}

},

bindButtons() {

document.querySelectorAll(

".mehaci-wishlist-btn"

).forEach(button => {

if (button.dataset.loaded)

return;

button.dataset.loaded = "true";

button.addEventListener(

"click",

e => {

e.preventDefault();

e.stopPropagation();

button.classList.add("loading");

const product = {

id: button.dataset.productId,

handle: button.dataset.productHandle,

title: button.dataset.productTitle,

url: button.dataset.productUrl,

image: button.dataset.productImage,

price: button.dataset.productPrice

};

setTimeout(() => {

Wishlist.toggle(product);

button.classList.remove("loading");

},250);

}

);

});

},

updateIcons() {

document.querySelectorAll(

".mehaci-wishlist-btn"

).forEach(button=>{

const id = button.dataset.productId;

if(this.exists(id)){

button.classList.add("active");

}

else{

button.classList.remove("active");

}

});

},

updateCounter() {

const counters = document.querySelectorAll(

".wishlist-count"

);

counters.forEach(counter=>{

counter.textContent=this.items.length;

});

},

observeDOM() {

const observer = new MutationObserver(

() => {

Wishlist.bindButtons();

Wishlist.updateIcons();

}

);

observer.observe(

document.body,

{

childList:true,

subtree:true

}

);

}

};

document.addEventListener(

"DOMContentLoaded",

function(){

Wishlist.init();

});


/* ===================================================
   Mehaci Premium Wishlist
   Part 2
   Wishlist Page + AJAX Cart
=================================================== */

Wishlist.money = function(value){

if(!value) return "";

let price = parseFloat(value);

if(isNaN(price)) return value;

return "₹" + price.toLocaleString("en-IN");

};

Wishlist.renderWishlist = function(){

const container = document.getElementById("mehaciWishlist");

if(!container) return;

if(this.items.length===0){

container.innerHTML=`

<div class="mehaci-empty">

<h2>Your Wishlist is Empty</h2>

<p>Save your favourite fragrances to purchase later.</p>

<a href="/collections/all" class="button">

Continue Shopping

</a>

</div>

`;

return;

}

let html='<div class="mehaci-wishlist-grid">';

this.items.forEach(product=>{

html+=`

<div class="mehaci-wishlist-card">

<a href="${product.url}" class="wishlist-image">

<img src="${product.image}" alt="${product.title}">

</a>

<div class="wishlist-content">

<h3>

<a href="${product.url}">

${product.title}

</a>

</h3>

<div class="wishlist-price">

${this.money(product.price)}

</div>

<div class="wishlist-actions">

<button

class="wishlist-cart"

data-handle="${product.handle}"

>

Add to Cart

</button>

<button

class="wishlist-remove"

data-id="${product.id}"

>

Remove

</button>

</div>

</div>

</div>

`;

});

html+="</div>";

container.innerHTML=html;

this.bindWishlistButtons();

};

Wishlist.bindWishlistButtons=function(){

document.querySelectorAll(".wishlist-remove")

.forEach(button=>{

button.onclick=()=>{

Wishlist.remove(button.dataset.id);

Wishlist.renderWishlist();

};

});

document.querySelectorAll(".wishlist-cart")

.forEach(button=>{

button.onclick=()=>{

Wishlist.addToCart(button);

};

});

};

Wishlist.addToCart=function(button){

button.disabled=true;

button.innerHTML="Adding...";

fetch("/products/"+button.dataset.handle+".js")

.then(r=>r.json())

.then(product=>{

return fetch("/cart/add.js",{

method:"POST",

headers:{

"Content-Type":"application/json"

},

body:JSON.stringify({

id:product.variants[0].id,

quantity:1

})

});

})

.then(r=>r.json())

.then(()=>{

button.innerHTML="Added ✓";

document.dispatchEvent(

new CustomEvent("cart:refresh")

);

setTimeout(()=>{

button.disabled=false;

button.innerHTML="Add to Cart";

},1500);

})

.catch(()=>{

button.disabled=false;

button.innerHTML="Try Again";

});

};

document.addEventListener(

"wishlist:updated",

function(){

Wishlist.renderWishlist();

}

);

document.addEventListener(

"DOMContentLoaded",

function(){

Wishlist.renderWishlist();

}

);

/*=====================================================
MEHACI PREMIUM WISHLIST
PART 3
Toast Notifications + Counter + Animations
======================================================*/


Wishlist.showToast=function(message){

let toast=document.querySelector(".mehaci-toast");

if(!toast){

toast=document.createElement("div");

toast.className="mehaci-toast";

document.body.appendChild(toast);

}

toast.innerHTML=message;

toast.classList.add("show");

clearTimeout(Wishlist.toastTimer);

Wishlist.toastTimer=setTimeout(function(){

toast.classList.remove("show");

},2500);

};



Wishlist.add=function(product){

if(this.exists(product.id)) return;

this.items.push(product);

this.save();

this.updateIcons();

this.updateCounter();

this.showToast("❤ Added to Wishlist");

document.dispatchEvent(

new CustomEvent("wishlist:updated")

);

};



Wishlist.remove=function(id){

this.items=this.items.filter(

item=>item.id!=id

);

this.save();

this.updateIcons();

this.updateCounter();

this.showToast("Removed from Wishlist");

document.dispatchEvent(

new CustomEvent("wishlist:updated")

);

};



Wishlist.updateCounter=function(){

let count=this.items.length;

document.querySelectorAll(".wishlist-count")

.forEach(function(counter){

counter.innerHTML=count;

});

};



Wishlist.animateHearts=function(){

document.querySelectorAll(".mehaci-wishlist-btn")

.forEach(function(btn){

btn.addEventListener("click",function(){

btn.classList.add("heart-pop");

setTimeout(function(){

btn.classList.remove("heart-pop");

},350);

});

});

};



document.addEventListener(

"wishlist:updated",

function(){

Wishlist.renderWishlist();

Wishlist.updateCounter();

}

);



document.addEventListener(

"DOMContentLoaded",

function(){

Wishlist.animateHearts();

Wishlist.renderWishlist();

Wishlist.updateCounter();

}

);



document.addEventListener("DOMContentLoaded", updateWishlistCounter);
document.addEventListener("wishlist:updated", updateWishlistCounter);

function updateWishlistCounter(){

    let items=[];

    try{
        items=JSON.parse(localStorage.getItem("mehaciWishlist"))||[];
    }catch(e){
        items=[];
    }

    document.querySelectorAll(".wishlist-count").forEach(function(el){

        if(items.length>0){

            el.textContent=items.length;
            el.style.display="flex";

        }else{

            el.textContent="";
            el.style.display="none";

        }

    });

}